import Component from './component'

import EnhancePopUpAlerts from './enhancers/EnhancePopUpAlerts'

export default EnhancePopUpAlerts(Component)
